import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import React from "react";
import NoPage from "./components/NoPage";
import Home from "./containers/Home";
import NewsPage from "./containers/news/NewsPage";
import LoanCalculator from "./hp-calculator/HPCalculator";

function App() {
  return (
    <BrowserRouter basename="/old">
      <Routes>
        <Route path="/*" element={<NoPage />} />
        <Route path="/" element={<Home />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/calculator" element={<LoanCalculator/>}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
